export const portfolioData = {
  name: "Chetan Jindal",
  role: "Full Stack Developer",
  location: "Asansol, West Bengal, India",
  email: "chetan.jindal96@gmail.com",
  linkedin: "https://www.linkedin.com/in/chetan-jindal-229081127/",

  about:
    "Results-driven Full Stack Developer with 4.5+ years of experience building scalable, high-performance web applications using MERN and MEAN stacks. Specialized in backend architecture, API development, performance optimization, and cloud deployment.",

  skills: [
    "Node.js",
    "Express.js",
    "MongoDB",
    "MySQL",
    "PostgreSQL",
    "React.js",
    "Redux",
    "Angular",
    "AWS (S3, EC2)",
    "REST APIs",
    "WebSockets",
    "Microservices",
  ],

  experience: [
    {
      company: "Webvio Technology Pvt. Ltd",
      role: "Full Stack Developer & Team Leader",
      period: "2025 - Present",
    },
    {
      company: "Webguru InfoSystem Pvt. Ltd",
      role: "Full Stack Developer",
      period: "2023 - 2025",
    },
    {
      company: "Step to Soft",
      role: "Jr Backend Developer",
      period: "2021 - 2023",
    },
  ],

  projects: [
    {
      name: "E-Commerce Platform",
      tech: "MERN Stack",
      description:
        "Built scalable ecommerce system handling thousands of products and transactions.",
    },
    {
      name: "Photography Marketplace App",
      tech: "MERN + WebSockets",
      description:
        "Realtime image updates and photographer marketplace platform.",
    },
    {
      name: "AI Chatbot",
      tech: "OpenAI + Node + React",
      description:
        "Developed AI-powered chatbot for realtime user interaction.",
    },
  ],

  achievements: [
    {
      label: "Years Experience",
      value: 4.5,
      prefix: "",
      suffix: "+",
      decimals: 1,
    },
    {
      label: "APIs Built",
      value: 300,
      prefix: "",
      suffix: "+",
      decimals: 0,
    },
    {
      label: "Performance Improvement",
      value: 30,
      prefix: "",
      suffix: "%",
      decimals: 0,
    },
    {
      label: "Faster Load Time",
      value: 40,
      prefix: "",
      suffix: "%",
      decimals: 0,
    },
  ],

  keyAchievements: [
    "Built and optimized 15+ scalable REST APIs improving backend performance by 30%.",
    "Led a development team delivering production-scale MEAN/MERN applications.",
    "Implemented real-time systems using WebSockets for live messaging and updates.",
    "Improved frontend performance by 40% using lazy loading and smart caching.",
  ],

  sections: {
    aboutTitle: "About",
    skillsTitle: "Skills",
    experienceTitle: "Experience",
    projectsTitle: "Projects",
    contactTitle: "Contact",
  },

  hero: {
    tagline:
      "Full Stack Developer | Scalable Backend Systems | Node.js & React Specialist",
    locationIcon: "Location:",
    separator: "|",
    resumeLabel: "Download Resume",
    contactLabel: "Contact Me",
    snapshotTitle: "Snapshot",
    snapshotRoleLabel: "Role:",
    snapshotLocationLabel: "Location:",
    snapshotStackLabel: "Core Stack:",
  },

  contact: {
    introPrefix: "For roles, collaborations, or consulting, reach out at",
    introConnector: "or connect on",
    linkedinLabel: "LinkedIn",
    introSuffix: ".",
    form: {
      nameLabel: "Name",
      namePlaceholder: "Your name",
      emailLabel: "Email",
      emailPlaceholder: "you@example.com",
      messageLabel: "Message",
      messagePlaceholder: "Share a bit about what you would like to build.",
      submitLabel: "Send Message",
    },
  },
};
